import { render, staticRenderFns } from "./FundMessagePage.vue?vue&type=template&id=06b94297&"
import script from "./FundMessagePage.vue?vue&type=script&lang=ts&"
export * from "./FundMessagePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports